import React from 'react';

const MealPlanHeader = ({ customer }) => (
    <>
        <div style={{
            borderBottom: '1px solid #eee',
            padding: 'clamp(10px, 3vw, 20px)',
            backgroundImage: 'url("/header-bg.jpg")',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            position: 'relative',
            minHeight: 'clamp(140px, 20vh, 170px)'
        }}>
            {/* Black overlay for better text readability */}
            <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.6)',
                zIndex: 1
            }} />
            <h1 style={{
                margin: '0 0 5px 0',
                color: '#ffffff',
                fontFamily: 'Georgia, serif',
                fontSize: 'clamp(28px, 8vw, 50px)',
                position: 'relative',
                zIndex: 2,
                paddingTop: '10px'
            }}>
                Square Fare
            </h1>
            <h1 style={{
                margin: '0 0 5px 0',
                color: '#ffffff',
                fontFamily: 'Georgia, serif',
                fontSize: 'clamp(20px, 6vw, 40px)',
                position: 'relative',
                zIndex: 2,
                paddingTop: '5px'
            }}>
                Personalized Meal Plan
            </h1>
            <p style={{
                fontWeight: 'bold',
                margin: '0',
                color: '#ffffff',
                fontSize: 'clamp(12px, 3.5vw, 20px)',
                position: 'relative',
                zIndex: 2,
                paddingTop: '15px',
                wordBreak: 'break-word'
            }}>
                {customer.name} • {customer.email}
            </p>
        </div>
    </>
);

export default MealPlanHeader;